import { NextSeo, WebPageJsonLd } from "next-seo";
import { useRouter } from "next/router";
import { FreeFortuneContent } from "shared/types";

interface Props {
  freeFortuneContent: FreeFortuneContent;
}

const ContentSeo = ({ freeFortuneContent }: Props) => {
  const router = useRouter();
  return (
    <>
      <NextSeo
        title={freeFortuneContent.title}
        description={freeFortuneContent.description}
        additionalLinkTags={[{ rel: "icon", href: "/favicon.ico" }]}
      />
      <WebPageJsonLd
        id={`https://miror.jp${router.asPath}`}
        description={freeFortuneContent.fortuneTellerProfile}
        lastReviewed={freeFortuneContent.lastmod}
        reviewedBy={{
          type: "Person",
          name: freeFortuneContent.fortuneTeller.name,
        }}
      />
    </>
  );
};

export default ContentSeo;
